Service = App.loadClass 'core::Angular/Service'

class exports.DataManagementService extends Service
    constructor: (@http, @rootScope) ->
        @rows = null


    getRows: (type) =>
        return @http.post 'backend/grower/maps-conversion/get-rows', { type }

    setRows: (rows) =>
        @rows = rows

    getManagementZoneRows: (skip, take) =>
        return @http.post 'backend/grower/maps-conversion/get-management-zone-rows', { skip, take }

    getGroupByValues: (row) =>
        return @http.post 'backend/grower/maps-conversion/get-group-by-values', { row }

    saveSelections: (altered_row, tab) =>
        savedSelections = []
        # For each parent row, build selections of it and its children
        for i, row of @rows
            selections =
                field_id: row.reference.field_id
                year: row.reference.year
                selected: row.selected
                children: []

            for i, child of row.children
                childSelections =
                    id: child.end.id
                    selected: child.selected

                selections.children.push childSelections

            savedSelections.push selections

        @persistSelections tab, savedSelections, altered_row


    persistSelections: (tab, selections, row) =>
        @http.post('backend/grower/maps-conversion/save-user-selections',
            tab: tab
            user_selections: selections
        ).then (response) =>
            @rootScope.$broadcast('row:updated', { row: row })

    loadScopeData: (promise, key) =>
        promise.then (response) =>
            if response?.data?.status?.type is 'success'
                @scope[key] = response.data.data
        return promise

    getSeedCompanies: (row) =>
        # get seed companies
        @http.post 'backend/grower/maps-conversion/get-seed-companies',
            crops_id: row.selected.crop.id
        .then (response) =>
            if response.data.status.type is 'success'
                row.selected.seed_company = null
                row.selected.product = null
                row.required.seed_companies = response.data.data

                # set children if we are on the parent row
                if row.children?
                    for i, child of row.children
                        child.selected.seed_company = null
                        child.selected.product = null
                        child.required.seed_companies = response.data.data
            @saveSelections(row, @tab)


    getProducts: (row, rows) =>
        crops_id = row.selected.crop.id
        sc_id = row.selected.seed_company.id

        @http.post 'backend/grower/maps-conversion/get-products',
            crops_id: crops_id, seed_companies_id: sc_id
        .then (response) =>
            if response.data.status.type is 'success'
                row.selected.product = null
                row.required.products = response.data.data
                # set children if we are on the parent row
                if row.children?
                    for i, child of row.children
                        child.selected.product = null
                        child.required.products = response.data.data
            @saveSelections(row, @tab)

    getConfirmedSettings: (vps) =>
        return @http.post 'backend/grower/maps-conversion/get-confirmed-settings',
            vps: vps
